// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._33xn8Zs4Ap4q3G {\n  color: #172B4D;\n  display: flex;\n  font-size: 1.2rem;\n  gap: 0.25rem;\n  text-decoration: none;\n  transition: 0.2s gap ease;\n}\n._33xn8Zs4Ap4q3G:hover {\n  gap: 0.5rem;\n  color: #172B4D;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryLink": "_33xn8Zs4Ap4q3G"
};
export default ___CSS_LOADER_EXPORT___;
